import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  { emoji: '👨', title: 'pages.onboarding.gender.male', value: 'male' },
  { emoji: '👩', title: 'pages.onboarding.gender.female', value: 'female' },
]

export default function GenderQuestionPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.gender.title"
      subtitle="pages.onboarding.gender.subtitle"
    />
  )
}
